<div class="tabTitle">
  <h6 class="center">{{ qualification.qualification_name }}</h6>
  <div class="col-md-1 tooltip-visible" style="width: 0px">
    <div class="fa fa-info-circle setting-info">
      <p>
        <span>
          Order Process:
          <ol>
            <li>
              Download the {{ qualification.qualification_name }} Template.
            </li>
            <li>Upload the completed Template.</li>
            <li>View the current upload.</li>
            <li>If needed, clear the upload and start over.s</li>
          </ol>
          If you would like to add quota's to your
          {{ qualification.qualification_name }}, this can be started in the CSV
          file that you upload. Do as follows:
          <ol>
            <li>
              Column A should have all your desired
              {{ qualification.qualification_name }}.
            </li>
            <li>
              Column B will have the name of the quota
              <ol type="i">
                <li>
                  If you would like an individual quota for each
                  {{ qualification.qualification_name }}, you need to have a
                  unique name for each row in your CSV file
                </li>
                <li>
                  If you would like multiple
                  {{ qualification.qualification_name }} to be part of a single
                  quota, you need to put that quota name (example: Store
                  Location B) next to each relevant
                  {{ qualification.qualification_name }}. This will bundle those
                  {{ qualification.qualification_name }} into a single quota, we
                  will edit the quota count in step 4.
                </li>
              </ol>
            </li>
            <li>Upload the CSV.</li>
            <li>
              You can edit the quota goals by clicking on the “Add Quotas” link
              below the {{ qualification.qualification_name }}.
            </li>
          </ol>
        </span>
      </p>
    </div>
  </div>
</div>
<div class="clearfix"></div>
<div class="row">
  <header class="flex-container flex-center color-green">
    <ul class="style-none">
      <li *ngIf="quotaFlags.add">
        <a
          class="link-cursor"
          (click)="openZipcodesQuotaModal()"
          [ngClass]="{ 'btn-disabled': isQlcLiveSurvey }"
          ><span>Add Quotas</span></a
        >
      </li>
      <br />
      <div
        style="display: flex; flex-direction: row; justify-content: center"
        *ngIf="quotaFlags.edit"
      >
        <li style="padding-right: 5px">
          <a class="link-cursor" (click)="openZipcodesQuotaModal()">
            <span>Edit Quotas</span>
          </a>
        </li>
        <li style="padding-left: 5px">
          <a
            class="link-cursor"
            (click)="deleteMultiselectInputQuotas()"
            [ngClass]="{ 'btn-disabled': isQlcLiveSurvey }"
          >
            <span>Clear Quotas</span>
          </a>
        </li>
      </div>
      <br />
      <ng-container *ngIf="!quotaFlags.edit">
        <li>
          <a
            target="_blank"
            class="text-decoration-none"
            href="{{ locationTemplate }}"
          >
            Download Template
          </a>
        </li>
        <br />
        <li>
          <input
            #fileUpload
            hidden
            type="file"
            class="file-upload"
            accept=".csv"
            (change)="uploadLocationFile($event)"
            psUiGtagEvent
            trackOn="change"
            action="file_upload"
            category="GEO"
            [params]="{ event_label: 'File Upload' }"
          />
          <button
            type="button"
            class="btn upload-button"
            (click)="fileUpload.value = ''; fileUpload.click()"
          >
            Upload a file
          </button>
        </li>
        <li>
          <span class="csv-span">.csv</span>
        </li>
        <li>
          <a class="link-cursor" (click)="downloadCurrentLocationFile()"
            >Download Current File</a
          >
        </li>
        <li>
          <h6 class="or-span">or</h6>
        </li>
        <li>
          <a class="link-cursor" (click)="clearZipcodes()"
            ><span>Clear upload</span></a
          >
        </li>
      </ng-container>
    </ul>
  </header>
</div>
